import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Button, Typography } from "@mui/material";
import { UnauthenticationDialog } from "components/dialog/UnauthenticationDialog";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PromotionalCTA.css";

interface PromotionalCTAProps {
  isLogin: boolean;
}

export const PromotionalCTA = ({ isLogin }: PromotionalCTAProps) => {
  const [openAuthDialog, setOpenAuthDialog] = useState(false);
  const navigate = useNavigate();

  if (isLogin) {
    return null;
  }

  const handleClick = () => {
    if (!isLogin) {
      setOpenAuthDialog(true);
    } else {
      navigate("/search");
    }
  };

  return (
    <div className="promotional-cta">
      <Typography className="promotional-cta__title">
        See what's possible before anything is made
      </Typography>
      <Button
        variant="contained"
        onClick={handleClick}
        endIcon={<ArrowForwardIcon />}
        className="promotional-cta__button"
      >
        Get free access to the full library
      </Button>
      {openAuthDialog && (
        <UnauthenticationDialog
          isOpen={openAuthDialog}
          onClose={setOpenAuthDialog}
        />
      )}
    </div>
  );
};
